import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import bookingChangesApi from '@/features/dashboard/bookingChanges/api/bookingChangesApi.ts';
import { bookingChangesApiQueryKeys } from '@/features/dashboard/bookingChanges/api/bookingChangesApi.queryKeys.ts';
import { ChangePreviewDto } from '@/features/dashboard/bookingChanges/types/dto/ChangePreviewDto.ts';
import { isCachedOpenChange } from '@/features/dashboard/bookingChanges/hooks/useGetOpenDraft.ts';

/**
 * Wpływ otwartej paczki na kwoty — rachunek docelowy i delty w trzech
 * ziarnistościach.
 *
 * Krótki `staleTime`, bo każda edycja pozycji zmienia kwoty; ponowień nie ma,
 * bo odmowa podglądu jest zawsze rozstrzygnięciem (walidacja transportu),
 * a nie usterką sieci.
 *
 * `enabled` jest funkcją, bo React Query rozstrzyga je dopiero w chwili
 * odpytania: po zamknięciu paczki unieważnienie kluczy wyprzedza przerysowanie
 * ekranów i wersja obliczona przy renderze pchnęłaby żądanie o paczkę już
 * zamkniętą — a takiej backend odmawia.
 */
const useGetChangePreview = (
  bookingId: string | undefined,
  changeId: string | undefined,
) => useQuery(getChangePreviewQueryOptions(bookingId, changeId));

export const getChangePreviewQueryOptions = (
  bookingId: string | undefined,
  changeId: string | undefined,
): UseQueryOptions<ChangePreviewDto> => ({
  queryKey: bookingChangesApiQueryKeys.preview(bookingId ?? '', changeId ?? ''),
  queryFn: () => bookingChangesApi.getPreview(bookingId!, changeId!),
  enabled: () => isCachedOpenChange(bookingId, changeId),
  staleTime: 1000 * 10,
  retry: false,
});

export default useGetChangePreview;
